<template>
  <div class="detail-layout-page-title">
    <h1 v-if="title" class="title is-h1 text-balance">
      <template v-if="isSustainable || rating">
        <span v-if="titlePrefix">{{ titlePrefix }}&nbsp;</span>
        <span class="no-wrap">
          {{ lastWord
          }}<SustainableLeaf v-if="isSustainable" /><AccomodationRating
            v-if="rating"
            v-bind="rating"
        /></span>
      </template>
      <span v-else>{{ title }}</span>
    </h1>
    <div v-if="lead" class="subtitle is-h3 text-balance">{{ lead }}</div>
  </div>
</template>

<script setup lang="ts">
import type { AccomodationRatingFragment } from '#graphql-operations'

const props = defineProps<{
  title: string
  lead: string
  isSustainable?: boolean
  rating?: AccomodationRatingFragment
}>()

const titleWords = computed(() =>
  props.title
    .split(' ')
    .map((v) => v.trim())
    .filter(Boolean),
)

const lastWord = computed(() => titleWords.value[titleWords.value.length - 1])

const titlePrefix = computed(() =>
  titleWords.value.slice(0, titleWords.value.length - 1).join(' '),
)
</script>
